// 花嫁「返しの一閃」をヴェールの刃で振り下ろす比較版 (2026-10-23・開発版 ?brideKaeshi=blade だけ)。
//
// 作者の答え (返しの一閃の答えるページ He7YpFWsB44ZcusZsogv82・10-23)：
//   問1 振り方＝B 三日月で振り下ろす (頭上へ振りかぶり、大きな三日月の刃を前の床へ向けて振り下ろす・見本 kaeshi_blade_B_downcut)。
//   問2 刃＝斬る瞬間だけ固い刃、すぐ柔らかく垂れた布に戻る。
//   問3 花びら＝当たった時だけ。ハートは無し。
// 検収の答え (kensyu-bride-kaeshi-blade-1023.html・10-23)：
//   B-1 刃に見える・「エフェクトは布ではなく刃物の切っ先の軌道のようなエフェクトにしてほしい」
//   B-2 うるさい・「軽く火花が散る程度に花びらを散らしてほしい」
//   B-3 直してからもう一度
// 作り：
//   技の数値 (溜め 350・当たり 150・隙 650・弾く回数) は配布版の返しの一閃のまま。当たりの前端だけ刀の切っ先に合わせた (下の BLADE_STRIKE_TO_PX)。
//   体＝振りかぶり issen_raise_1023 → 振り下ろしの中割り issen_swing_1023 → ヴェールを刀にして振り抜いた kaeshi_cut_1023 → 立ち姿 veil_follow。
//   刃の跡＝切っ先が通った細い軌跡。当たりの 150ms の間に、頭の上から刀の切っ先まで弧をなぞる。
//     切っ先の所がいちばん太く明るく (7px)、後ろへ行くほど細く薄くなって消える (武器の軌跡と同じ作り・render.ts drawContactSmearTrail)。
//     当たりが終わると後ろから縮んで 0.16 秒で消える。
//   花びらは無し (3回目の検収 B-2「花びらの案は却下で。外して」)。
//   赤・朱・マゼンタは使わない (赤＝弾けない攻撃の専用色)。色は冷たい銀と藤色。
// 配布版は URL を読まない (setBrideKaeshi が import.meta.env.DEV の時だけ入れる)。
//   ⚠️ 識別子に URL のキーの綴りを入れない (scripts/check_dev_leak.mjs)。
// 記録 = docs/research/2026-10-23-bride-kaeshi-blade.md・直し＝-redo.md・-smooth.md・刀の絵＝docs/research/2026-10-23-bride-kaeshi-cut.md

import { ATTACKS } from './attacks'
import { PALETTE } from './balance'
import { BOSS_ATTACK_TIMELINES, type BossAttackTimeline } from './boss_pose_timeline'
import type { Boss } from './types'

// 3回目の検収 (10-23)：B-1「滑らかだが動きが鈍くなった」「カクカクしているし、ヴェールを振って刀のようにしているようには見えない」・B-2「花びらの案は却下で。外して」。
//   鈍くなった原因 (測った)：①振り下ろしの絵を溜めの 0.45 から出したので、当たりの前に止まった振りの絵が 193ms 見えていた
//   ②沈みの絵をゆっくり起こし (0.4 まで easeInOut)、立ち姿も低い所から伸ばしたので、振りの速さが体に残らなかった。
//   刀に見えない原因：一閃の3枚はどれもヴェールが後ろへ弧を描くスカーフで、前へ伸びた刃の絵が1枚も無かった。軌跡も布と離れた所に浮いていた。
//   直し＝ヴェールを硬い刃にして前の床へ振り抜いた絵 kaeshi_cut_1023 (Codex・1枚) を足し、
//   ①振りかぶり (issen_raise) を溜めの 0.82 まで持って後ろへ引き絞る ②振り下ろし (issen_swing) は 4 コマだけ通る中割り
//   ③当たりの頭で刀の絵へパッと替え、後ろから前へ easeOut で振り抜く ④刀の絵のまま隙の半分まで止める (振り抜いた後の残心)
//   ⑤ヴェールが布へほどける絵 (veil_sweep_contact) を一瞬はさんで立ち姿へ戻す (刀の絵から直に戻すと外形が 72px 飛んだ)。
//   切っ先の軌跡は振り下ろしの絵の間に頭の上から走り出し、当たりの頭から HEAD_REACH_MS で刀の切っ先へ着く
//   (等速で見ると、当たりの間 150ms かけて伸ばした軌跡は刀の絵より遅れて別の斬撃に見えた)。
//   刀の切っ先は当たりの前端 102px より前 (約 150px) に出るので、この版だけ当たりの前端を切っ先に合わせた (当たりは絵に合わせる)。
export const BRIDE_KAESHI_BLADE_TIMELINE: BossAttackTimeline = [
  { phase: 'telegraph', at: 0.0, image: 'issen_raise_1023', hold: true, tag: 'anticipation', ease: 'easeOut' },
  { phase: 'telegraph', at: 0.82, image: 'issen_raise_1023', hold: true, ease: 'step', offset: { x: -8 }, rot: -3, scale: { y: 1.02 } },
  { phase: 'telegraph', at: 0.82, image: 'issen_swing_1023', hold: true, ease: 'easeIn', offset: { x: -4 } },
  { phase: 'active', at: 0.0, image: 'issen_swing_1023', hold: true, ease: 'step', offset: { x: 6 }, rot: 3 },
  { phase: 'active', at: 0.0, image: 'kaeshi_cut_1023', hold: true, tag: 'contact', ease: 'easeOut', offset: { x: -12 }, rot: -4 },
  { phase: 'active', at: 0.6, image: 'kaeshi_cut_1023', hold: true, ease: 'linear' },
  { phase: 'recovery', at: 0.0, image: 'kaeshi_cut_1023', hold: true, tag: 'followThrough', ease: 'linear' },
  { phase: 'recovery', at: 0.5, image: 'kaeshi_cut_1023', hold: true, ease: 'step', offset: { x: 2 } },
  { phase: 'recovery', at: 0.5, image: 'veil_sweep_contact', ease: 'step' },
  { phase: 'recovery', at: 0.6, image: 'veil_sweep_contact', hold: true, ease: 'step' },
  { phase: 'recovery', at: 0.6, image: 'veil_follow', tag: 'followThrough', ease: 'easeOut', scale: { x: 1.04, y: 0.93 }, offset: { x: 4 } },
  { phase: 'recovery', at: 0.85, image: 'veil_follow', ease: 'linear' },
]

/** 刀の絵の切っ先 (ボスの足元から前へ・上へ px)。kaeshi_cut_1023 の左端 (絵の画素 x 10・y 955) を置き場所と倍率で写した値。 */
export const BLADE_TIP = { fwd: 150, up: 5 }
/** この版の当たりの前端 (切っ先に合わせる)。配布版は 102。 */
export const BLADE_STRIKE_TO_PX = BLADE_TIP.fwd

let on = false
export function brideKaeshiBladeOn(): boolean { return on }
// bride_kaeshi.ts の setBrideKaeshi から呼ぶ (返しの一閃の並びを上書きするため、setBrideMotionArt・setBrideIssen の後)。
export function setBrideKaeshiBlade(enabled: boolean): void {
  const a = ATTACKS.veilSweepLink!
  shipStrikeTo ??= a.strike?.localToPx ?? null
  const was = on
  on = import.meta.env.DEV && enabled
  if (on) BOSS_ATTACK_TIMELINES['bride']!.veilSweepLink = BRIDE_KAESHI_BLADE_TIMELINE
  // 当たりの前端は、この版の間だけ切っ先に合わせ、外したら配布版の値へ戻す。
  if (a.strike && shipStrikeTo !== null && (on || was)) a.strike = { ...a.strike, localToPx: on ? BLADE_STRIKE_TO_PX : shipStrikeTo }
}
let shipStrikeTo: number | null = null

// ───────── 切っ先の軌跡 (ボスの足元から・前＝+x・上＝+y) ─────────
/** 切っ先が通る弧の中心。弧の終わりは刀の切っ先 (BLADE_TIP)、始まりは頭の上の少し後ろ。 */
export const BLADE_CENTER = { fwd: 10, up: 50 }
export const BLADE_RADIUS = Math.hypot(BLADE_TIP.fwd - BLADE_CENTER.fwd, BLADE_TIP.up - BLADE_CENTER.up)
/** 弧の始まりと終わりの角度 (度・0＝前・90＝真上)。 */
export const BLADE_FROM_DEG = 110
export const BLADE_TO_DEG = Math.atan2(BLADE_TIP.up - BLADE_CENTER.up, BLADE_TIP.fwd - BLADE_CENTER.fwd) * 180 / Math.PI
/** 切っ先の所の太さ (px)。後ろへ行くほど細くなる。 */
export const TRAIL_HEAD_W = 7
/** 軌跡の長さ (弧の何割ぶん後ろまで見えるか)。 */
const TRAIL_LEN = 0.75
/** 当たりが終わってから消えるまで (秒)。 */
export const TRAIL_FADE_S = 0.16
const SAMPLES = 28
/** 軌跡が走り始めるのは当たりの何 ms 前か (振り下ろしの絵が出ている間)。 */
export const SWING_LEAD_MS = 63
/** 当たりの頭で、軌跡の先が弧のどこまで来ているか。 */
const HEAD_AT_CONTACT = 0.55
/** 当たりの頭から軌跡の先が切っ先へ着くまで (ms)。刀の絵は当たりの頭で既に振り抜いているので、遅れて見えない短さにする。 */
export const HEAD_REACH_MS = 33

const TRAIL_CORE = '#f4f2fa'
const TRAIL_GLOW = PALETTE.fxVioletBright

export type Anchor = { x: number; footY: number; dir: number }
/** 軌跡がなぞる弧 (ボスの足元から・前＝+x・上＝+y)。返しの一閃の振りの跡だけの版 (bride_kaeshi_tween.ts) も同じ描き方で別の弧を使う。 */
export type ArcShape = { center: { fwd: number; up: number }; radius: number; fromDeg: number; toDeg: number; headW: number }
const BLADE_SHAPE: ArcShape = { center: BLADE_CENTER, radius: BLADE_RADIUS, fromDeg: BLADE_FROM_DEG, toDeg: BLADE_TO_DEG, headW: TRAIL_HEAD_W }
type Pt = { x: number; y: number }
let wasActive = false
let anchor: Anchor | null = null
let fadeFrom = -1
let lastTime = -1

/** 弧の上の w (0＝上の端・1＝前の床) の点。inset＝弧から内側へ寄せる量 (px)。 */
function arcPoint(a: Anchor, w: number, inset: number, sh: ArcShape): Pt {
  const th = (sh.fromDeg + (sh.toDeg - sh.fromDeg) * w) * Math.PI / 180
  const r = sh.radius - inset
  return { x: a.x + a.dir * (sh.center.fwd + Math.cos(th) * r), y: a.footY - (sh.center.up + Math.sin(th) * r) }
}

/**
 * 切っ先の軌跡の外の縁 (切っ先が通った線) と内の縁、各点の濃さ (0＝消える後ろの端・1＝切っ先)。
 * head＝切っ先の位置 (弧の上の 0〜1)、tail＝後ろの端の位置、width＝太さの倍率。
 */
export function bladeTrail(a: Anchor, tail: number, head: number, width = 1, sh: ArcShape = BLADE_SHAPE): { outer: Pt[]; inner: Pt[]; k: number[] } {
  const outer: Pt[] = [], inner: Pt[] = [], k: number[] = []
  const h = Math.max(0, Math.min(1, head)), t = Math.max(0, Math.min(h, tail))
  for (let i = 0; i <= SAMPLES; i++) {
    const u = i / SAMPLES
    const w = t + (h - t) * u
    // 切っ先の所が太く、後ろへ尖って消える (先の 8% だけ丸めて尖らせる)。
    const thick = sh.headW * width * Math.pow(u, 1.6) * Math.min(1, (1 - u) / 0.08 + 0.35)
    outer.push(arcPoint(a, w, 0, sh))
    inner.push(arcPoint(a, w, thick, sh))
    k.push(u)
  }
  return { outer, inner, k }
}

export function drawTrail(ctx: CanvasRenderingContext2D, a: Anchor, tail: number, head: number, fade: number, sh: ArcShape = BLADE_SHAPE): void {
  if (fade <= 0.01 || head - tail <= 0.01) return
  const fill = (b: { outer: Pt[]; inner: Pt[] }, color: string, alpha: number): void => {
    ctx.globalAlpha = alpha
    ctx.fillStyle = color
    ctx.beginPath()
    ctx.moveTo(b.outer[0]!.x, b.outer[0]!.y)
    for (const p of b.outer) ctx.lineTo(p.x, p.y)
    for (let i = b.inner.length - 1; i >= 0; i--) ctx.lineTo(b.inner[i]!.x, b.inner[i]!.y)
    ctx.closePath()
    ctx.fill()
  }
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  const main = bladeTrail(a, tail, head, 1, sh)
  // 藤色のにじみ → 細い銀の芯 → 切っ先が通った外の縁の順に重ねる。
  ctx.shadowColor = TRAIL_GLOW
  ctx.shadowBlur = 10 * fade
  fill(main, TRAIL_GLOW, 0.32 * fade)
  ctx.shadowBlur = 0
  fill(bladeTrail(a, tail, head, 0.45, sh), TRAIL_CORE, 0.5 * fade)
  ctx.strokeStyle = TRAIL_CORE
  ctx.lineCap = 'round'
  for (let i = 0; i < SAMPLES; i++) {
    const u = main.k[i + 1]!
    ctx.globalAlpha = fade * (0.04 + 0.9 * u * u)
    ctx.lineWidth = 0.6 + 1.8 * u * u
    ctx.beginPath()
    ctx.moveTo(main.outer[i]!.x, main.outer[i]!.y)
    ctx.lineTo(main.outer[i + 1]!.x, main.outer[i + 1]!.y)
    ctx.stroke()
  }
  ctx.restore()
}

/** 毎フレーム描く (ボスの絵の後)。軌跡は返しの一閃の当たりの間と、その直後の消える間。 */
export function drawBrideKaeshiBlade(ctx: CanvasRenderingContext2D, boss: Boss | null | undefined, time: number, footY: number): void {
  if (!on || !boss || boss.id !== 'bride') return
  if (time < lastTime) { anchor = null; fadeFrom = -1; wasActive = false }
  lastTime = time
  const dir = boss.facing === 'right' ? 1 : -1
  const atk = boss.currentAttack
  const active = boss.state === 'active' && atk?.id === 'veilSweepLink'
  const swinging = boss.state === 'telegraph' && atk?.id === 'veilSweepLink'
    && boss.stateElapsed * 1000 >= atk.chargeMs - SWING_LEAD_MS
  if (swinging) {
    // 振り下ろしの絵の間に、頭の上から刀の途中まで走る。
    anchor = { x: boss.x, footY, dir }
    const head = HEAD_AT_CONTACT * Math.min(1, (boss.stateElapsed * 1000 - (atk.chargeMs - SWING_LEAD_MS)) / SWING_LEAD_MS)
    drawTrail(ctx, anchor, head - TRAIL_LEN, head, 1)
  } else if (active) {
    // 当たりの頭で刀の絵に替わるので、軌跡も HEAD_REACH_MS で切っ先へ追いつき、そのまま残す。
    anchor = { x: boss.x, footY, dir }
    const r = Math.min(1, boss.stateElapsed * 1000 / HEAD_REACH_MS)
    const head = HEAD_AT_CONTACT + (1 - HEAD_AT_CONTACT) * (1 - Math.pow(1 - r, 2))
    drawTrail(ctx, anchor, head - TRAIL_LEN, head, 1)
    fadeFrom = -1
  } else if (wasActive && anchor) {
    fadeFrom = time
  }
  wasActive = active
  if (!active && anchor && fadeFrom >= 0) {
    // 振り切った後は後ろから縮み、薄くなって消える。
    const f = (time - fadeFrom) / TRAIL_FADE_S
    if (f >= 1) { anchor = null; fadeFrom = -1 } else drawTrail(ctx, anchor, 1 - TRAIL_LEN * (1 - f), 1, 1 - f)
  }
}

export function resetBrideKaeshiBladeForTest(): void {
  anchor = null; fadeFrom = -1; wasActive = false; lastTime = -1
}
